<template>
  <section class="page-container">
    <div class="flex-sb-center mg-b-30">
      <span class="title">Create Quote For</span>
      <v-button
        green
        @click="handleNext">Next</v-button>
    </div>
    <select-quote-type
      v-model="selectType"
      disable></select-quote-type>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="form-item width-335">
        <span>Source</span>
        <el-form-item
          ref="ref_agency_id"
          :rules="rules.select"
          prop="ref_agency_id">
          <v-select
            v-model="formData.ref_agency_id"
            :list="globalOptions.ref_agency"/>
        </el-form-item>
      </div>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import SelectQuoteType from '../components/select-quote-type'
export default {
  name: 'select-for-quote',
  components:{
    SelectQuoteType
  },
  mixins: [MixinOptions, MixinRules,MixinFormat],
  data(){
    return{
      selectType:'1',
      formData:{
        ref_agency_id:''
      }
    }
  },
  computed:{
    severType(){
      return this.selectType==1?'holdcover':'fina'
    },
    hasCustomer(){
      let {hasCustomer} = this.$route.query||{}
      return hasCustomer
    }
  },
  methods:{
    handleNext(){
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {}
          if(this.hasCustomer){
            params.hasCustomer  = true
          }
          this.$router.push({
            path:`/quoting/${this.severType}/index`,
            query:{
              source:this.formData.ref_agency_id,
              ...params
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  padding: 30px 70px;
  .title{
    font-weight: 600;
    font-size: 36px;
    color: $dark;
  }
.width-335{
  width: 335px;
}
}

</style>
